var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopupInfoWithProperties',{style:(_vm.styleVisible),attrs:{"data":_vm.localData},on:{"hide":_vm.handleHide,"show":_vm.handleShow}},[_c('IconMaterial',{staticClass:"information",attrs:{"title":"info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }